<template>
    <fragment>
        <v-col cols="12" sm="5" md="2" lg="2" class="teamname" v-if="myteam.id == ''">
            <v-text-field
            v-model="teamname"
            label="Team Name"
            :rules="fieldRules"
            type="text"
            required
            ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="2" lg="2" class="createteam" v-if="myteam.id == ''">
            <div class="create">
            <v-btn color="white" @click="createTeam"
                >CREATE A NEW TEAM</v-btn
            >
            </div>
        </v-col>
        <v-dialog v-model="dialog" max-width="290" v-if="myteam.id == ''">
            <v-card>
                <v-card-title class="headline">Create Team Status</v-card-title>
                <v-card-text>
                    <span>{{this.msg}}</span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small class="cancel" @click="closeDialog">Close</v-btn>
                    <!-- <v-btn color="green darken-1" @click="dialog = false">Close</v-btn> -->
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-col cols="12" sm="5" md="2" lg="2" class="createteam" v-if="myteam.id != ''">
            <span>My Team:  {{myteam.name}}</span>
        </v-col>
    </fragment>
</template>

<script>
export default {
    data() {
        return {
            teamname: "",
            fieldRules: [v => !!v || "Required"],
            dialog: false,

            msg: ''
        }
    },

    computed: {
        myteam() {
            return this.$store.state.user.profile.team;
        }
    },

    methods: {
        createTeam() {
            let newteam = this.teamname;
            this.$store.dispatch("createTeam", newteam).then(response => {
                this.$store.dispatch("getAllTeams");
                this.msg = response.data.status;
                this.dialog = true;
            });
        },
        closeDialog() {
            this.dialog = false;
            this.$store.dispatch("aboutMe");
        }
    }
}
</script>